export const packageList = [
  {
    name: 'qms',
    activeRule: ['qms'],
    preload: true,
  },
  {
    name: 'bids',
    activeRule: ['bids'],
  },
  {
    name: 'ims_supplier',
    activeRule: ['imsSupplier'],
  },
  {
    name: 'ims',
    activeRule: ['ims'],
    preload: true,
  },
  {
    name: 'ims_monitor',
    activeRule: ['ims-monitor'],
  },
  {
    name: 'ims_site',
    activeRule: ['ims-site'],
  },
  {
    name: 'ims_order',
    activeRule: ['ims-order'],
  },
]

export const remoteModuleConfig = {
  dev: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site', 'ims_order'],
  stg: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site', 'ims_order'],
  uat: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site', 'ims_order'],
  prd: ['qms', 'ims', 'bids', 'ims_supplier', 'ims_monitor', 'ims_site', 'ims_order'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/ims/index.js